import React from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { useForm } from '@morningtrain/react-resources'

export default function NormManagerFieldsForItems () {
  const [itemsById] = useEnvValue('globals.inventory.norms.by_item')

  const form = useForm()
  const itemsCountRef = React.useRef(null)

  if (!itemsById) {
    return null
  }

  const itemValues = Object.values(itemsById)
  if (!itemValues.length) {
    return null
  }

  return itemValues.map(itemNorms => {
    const itemNormValues = Object.values(itemNorms)

    return itemNormValues.map(itemNorm => {
      if (!itemNorm) {
        return null
      }

      return Object.keys(itemNorm).map(itemNormKey => {
        const key = [
          itemNorm.inventory_item_id,
          itemNorm.weekday,
          itemNormKey
        ].join('.')

        return (
          <React.Fragment key={key}>
            <input type='hidden' name={`norms[${itemNorm.inventory_item_id}][${itemNorm.weekday}][${itemNormKey}]`} value={itemNorm[itemNormKey] || 0} />
          </React.Fragment>
        )
      })
    })
  })
}
